import React from "react";
import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic, faPlay } from "@fortawesome/free-solid-svg-icons";
import { useAudio } from "../context/AudioContext";
import '../components/components.css';

const MyFiles = () => {
  const { playAudio } = useAudio();

  // Example audio files with proper URLs
  const audioFiles = [
    {
      id: 1,
      name: "Vocal Track 01.mp3",
      type: "Audio",
      size: "3.2 MB",
      lastModified: "2023-05-10",
      src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
    },
    {
      id: 2,
      name: "Beat Pattern.mp3",
      type: "Audio",
      size: "2.8 MB",
      lastModified: "2023-05-05",
      src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3"
    },
    {
      id: 3,
      name: "Guitar Solo.wav",
      type: "Audio",
      size: "5.1 MB",
      lastModified: "2023-05-01",
      src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3"
    },
    {
      id: 4,
      name: "Piano Melody.mp3",
      type: "Audio",
      size: "4.2 MB",
      lastModified: "2023-04-25",
      src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3"
    },
    {
      id: 5,
      name: "Drums Only.wav",
      type: "Audio",
      size: "8.3 MB",
      lastModified: "2023-04-20",
      src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3"
    }
  ];

  const handlePlayClick = (file) => {
    playAudio(file.src, file.name);
  };

  return (
    <div className="beats-component-container">
      <Container className="py-4">
        <h2 className="mb-4 beats-gradient">My Files</h2>
        <p className="text-secondary-light mb-4">
          Manage your audio files and play them using the music player.
        </p>

        <Row>
          <Col lg={8}>
            <Card className="beats-card mb-4">
              <Card.Header>
                <h3>Audio Library</h3>
              </Card.Header>
              <Card.Body>
                <ListGroup variant="flush">
                  {audioFiles.map((file) => (
                    <ListGroup.Item key={file.id} className="beats-list-item d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <FontAwesomeIcon icon={faMusic} className="me-3" />
                        <div>
                          <h5 className="mb-0">{file.name}</h5>
                          <small className="text-secondary">{file.type} • {file.size}</small>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="me-3 text-secondary">{file.lastModified}</span>
                        <button 
                          className="beats-btn-purple-ctrl rounded-circle p-2"
                          onClick={() => handlePlayClick(file)}
                        >
                          <FontAwesomeIcon icon={faPlay} />
                        </button>
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={4}>
            <Card className="beats-card">
              <Card.Header>
                <h3>Instructions</h3>
              </Card.Header>
              <Card.Body>
                <p className="text-secondary-light">
                  Click the play button next to any track to start playing it.
                  The music player will appear at the bottom of the screen.
                </p>
                <p className="text-secondary-light">
                  You can control playback, adjust volume, and seek through the track
                  using the controls in the player.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default MyFiles; 